"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.list.title': 'Tutoriales',
    'tutorial.list.empty.title': 'No se Encontraron Tutoriales',
    'tutorial.list.empty.message': 'Crea tu primer tutorial para comenzar con experiencias de aprendizaje interactivas.',
    'tutorial.expired': 'Caducado',
    'tutorial.draft': 'Borrador',
};
